module.exports = __webpack_public_path__ + "static/media/full_barbell_setup.a5098852.webp";